export default class BusinessUnit {
    constructor(props) {
        this.emails = '';
        Object.assign(this, props);
        this.image = props.image + '?dummy=' + makeid(3);
    }
}
export const makeid = (length) => {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/BusinessUnits/Model.ts
// module id = 152
// module chunks = 0